import { includes } from 'lodash'

import {
  ComplaintOrderType,
  ComplaintCreationItemReasonModel,
} from '@marketplace-web/domain/complaints-data'

const buildReasonOptions = (reasons?: Array<ComplaintCreationItemReasonModel>) => {
  return (
    reasons?.map(({ code, reasonText }) => ({
      value: code,
      label: reasonText,
    })) || []
  )
}

const isComplaintOrderSellerBusinessUser = (orderType?: ComplaintOrderType | null) => {
  return includes([ComplaintOrderType.B2B, ComplaintOrderType.B2C], orderType)
}

export { buildReasonOptions, isComplaintOrderSellerBusinessUser }
